import { useState } from 'react';
import { Link } from 'react-router-dom';
import PageMeta from '@/components/feature/PageMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const brandFeatures = [
  { icon: 'ri-shield-check-line', label: '权威公信力' },
  { icon: 'ri-flashlight-line', label: '首发速度' },
  { icon: 'ri-global-line', label: '覆盖广泛' },
  { icon: 'ri-key-2-line', label: '独家渠道' },
  { icon: 'ri-user-heart-line', label: '用户口碑' },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      setFormMessage('感谢您的留言，我们会尽快回复！');
      form.reset();
      return;
    }

    setFormStatus('loading');

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'phone_alt') {
          params.append(key, value as string);
        }
      });

      const response = await fetch('http://91flj.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      const parsed = JSON.parse(responseText);

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage(parsed?.meta?.message || '感谢您的留言，我们会尽快回复！');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText;
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormStatus('error');
          setFormMessage('提交失败，请稍后重试。');
        } else {
          setFormStatus('error');
          setFormMessage(serverMsg || '提交失败，请稍后重试。');
        }
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请稍后重试。');
    }
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'AboutPage',
        '@id': 'http://91flj.cn/about#about',
        name: '关于吃瓜爆料网',
        url: 'http://91flj.cn/about',
        description: '吃瓜爆料网是一个专注于网红塌房、黑料大瓜、反差视频、博主聊天记录曝光的娱乐资讯平台。每日首发更新最新爆料内容，致力为广大吃瓜群众提供最快速、最全面的娱乐资讯服务。',
        isPartOf: { '@id': 'http://91flj.cn/#website' },
        about: { '@id': 'http://91flj.cn/#organization' },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://91flj.cn/' },
          { '@type': 'ListItem', position: 2, name: '关于我们' },
        ],
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '吃瓜爆料网是否可靠？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '吃瓜爆料网始终坚持真实、客观的报道原则，所有爆料内容均经过多方位核实后发布，确保信息可靠性。',
            },
          },
          {
            '@type': 'Question',
            name: '如何联系吃瓜爆料网？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以通过网站底部的联系表单留言，或发送邮件至 hello@91flj.cn，我们会在24小时内回复。',
            },
          },
          {
            '@type': 'Question',
            name: '吃瓜爆料网的爆料来源是什么？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '我们的爆料来源包括行业内部人士投稿、热心网友爆料、公开新闻报道以及自有调查团队的深度挖掘，确保信息的多元化和客观性。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <PageMeta
        title="关于吃瓜爆料网 - 品牌介绍 | 吃瓜爆料网官网"
        description="吃瓜爆料网是一个专注于网红塌房、黑料大瓜、反差视频曝光的中文娱乐资讯平台。每日首发更新最新爆料内容，一站导航吃瓜爆料网官网、APP下载与最新地址。"
        keywords="吃瓜爆料网, 吃瓜爆料网官网, 吃瓜爆料网app, 关于吃瓜爆料网, 品牌介绍, 网红塌房, 黑料大瓜"
        canonicalUrl="http://91flj.cn/about"
        ogImage="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20scene%20of%20breaking%20news%20media%20room%20with%20warm%20amber%20lighting%20professional%20journalism%20atmosphere%20investigative%20reporting%20theme%20dark%20moody%20background%20editorial%20photography%20style&width=1200&height=630&seq=og-about&orientation=landscape"
        jsonLd={jsonLd}
      />

      <main>
        <Navbar />

        {/* 页面头部 */}
        <section className="w-full bg-background-50 pt-24 md:pt-28 pb-12 md:pb-16">
          <div className="px-4 md:px-6">
            {/* 面包屑 */}
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-foreground-400" />
              <span className="text-foreground-700">关于我们</span>
            </nav>

            <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
              <div className="w-full lg:w-[40%]">
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-extrabold text-foreground-950 leading-tight mb-4">
                  关于<strong>吃瓜爆料网</strong>
                </h1>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-md">
                  中国领先的娱乐资讯聚合平台，专注网红塌房、黑料大瓜、反差视频等热点内容，每日首发更新，为您带来最及时的爆料资讯。
                </p>
              </div>
              <div className="w-full lg:w-[60%]">
                <div className="rounded-2xl overflow-hidden aspect-[16/8]">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20scene%20of%20breaking%20news%20media%20room%20with%20warm%20amber%20lighting%2C%20professional%20journalism%20atmosphere%2C%20investigative%20reporting%20theme%2C%20dark%20moody%20background%20with%20monitors%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20mysterious%20composition&width=1200&height=600&seq=about-header-2026&orientation=landscape"
                    alt="关于吃瓜爆料网"
                    className="w-full h-full object-cover"
                    title="吃瓜爆料网品牌介绍"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 品牌主体 */}
        <section className="w-full bg-foreground-950 py-16 md:py-24">
          <div className="px-4 md:px-6">
            <div className="text-center mb-16">
              <span className="text-xs font-semibold tracking-widest uppercase text-secondary-400">ABOUT US</span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mt-2 max-w-2xl mx-auto leading-snug">
                我们致力于成为<strong className="text-primary-400">最值得信赖</strong>的娱乐资讯平台
              </h2>
              <p className="text-sm text-foreground-500 mt-4 max-w-lg mx-auto">
                以最快的速度、最真实的内容，为每一位吃瓜群众带来最优质的阅读体验
              </p>
              <div className="flex justify-center gap-3 mt-8">
                <Link
                  to="/"
                  className="whitespace-nowrap px-6 py-3 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors duration-200 cursor-pointer"
                >
                  浏览爆料
                </Link>
                <Link
                  to="/category/meiri-baoliao"
                  className="whitespace-nowrap px-6 py-3 border border-background-50/60 text-background-50 rounded-full text-sm font-semibold hover:bg-background-50/10 transition-colors duration-200 cursor-pointer"
                >
                  每日首发
                </Link>
              </div>
            </div>

            {/* 品牌特性 */}
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
              {brandFeatures.map((feature) => (
                <div
                  key={feature.label}
                  className="bg-foreground-900/50 rounded-2xl p-6 md:p-8 text-center border border-foreground-800/50 hover:border-primary-700/50 transition-colors duration-300"
                >
                  <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-foreground-800 flex items-center justify-center">
                    <i className={`${feature.icon} text-xl text-background-50`} />
                  </div>
                  <span className="text-sm text-background-50 font-medium whitespace-nowrap">
                    {feature.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 品牌故事 */}
        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6 text-center">
                品牌故事
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                <p>
                  <strong>吃瓜爆料网</strong>成立于2024年，是国内最早专注于网红爆料和娱乐资讯聚合的平台之一。我们的创始团队来自国内知名媒体和互联网公司，怀着"让真相不再被掩盖"的初心，打造了这个集<strong>网红塌房</strong>、<strong>黑料大瓜</strong>、反差视频、聊天记录曝光于一体的综合性资讯平台。
                </p>
                <p>
                  自上线以来，吃瓜爆料网凭借首发速度快、内容真实可靠的优势，迅速积累了数千万忠实用户。我们的编辑团队7x24小时不间断追踪热点事件，确保用户能在第一时间获取最新的<strong>每日爆料</strong>内容。
                </p>
                <p>
                  除了网站平台，我们还推出了<strong>吃瓜爆料网APP</strong>，支持iOS和安卓双平台下载。用户可以通过APP随时随地浏览最新爆料，享受更加便捷的阅读体验。访问<strong>吃瓜爆料网官网</strong>或<strong>吃瓜爆料网最新地址</strong>即可获取下载链接。
                </p>
                <p>
                  未来，吃瓜爆料网将继续坚持真实、客观、快速的报道原则，不断优化用户体验，扩展内容覆盖范围，力争成为华人世界最具影响力的娱乐资讯平台。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 用户口碑 */}
        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="text-xs font-semibold tracking-widest uppercase text-secondary-500">TESTIMONIALS</span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-600 mt-2">
                来自真实用户的评价与反馈
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
              <div className="bg-background-50 rounded-2xl p-6 border border-background-200/70">
                <div className="flex items-center gap-1 text-accent-500 mb-4">
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "自从关注了吃瓜爆料网，每天都有新瓜吃！更新速度真的太快了，每次网红塌房都是第一时间推送，已经推荐给身边所有朋友了。"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-user-line text-primary-500 text-sm" />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-foreground-950">资深吃瓜人</p>
                    <p className="text-xs text-foreground-500">使用2年</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-2xl p-6 border border-background-200/70">
                <div className="flex items-center gap-1 text-accent-500 mb-4">
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "APP做得太好用了，界面简洁流畅，分类也很清晰。聊天记录和反差视频板块最精彩，料太足了！吃瓜爆料网YYDS！"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-user-line text-accent-500 text-sm" />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-foreground-950">吃瓜不吐籽</p>
                    <p className="text-xs text-foreground-500">使用1年</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-2xl p-6 border border-background-200/70">
                <div className="flex items-center gap-1 text-accent-500 mb-4">
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-half-line" />
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "内容很丰富，爆料速度确实快。不过希望可以增加更多深度追踪报道，有些事件后续跟进不够及时。总体来说是非常值得推荐的平台。"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center">
                    <i className="ri-user-line text-secondary-500 text-sm" />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-foreground-950">理性观察者</p>
                    <p className="text-xs text-foreground-500">使用6个月</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 联系表单 */}
        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="px-4 md:px-6">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-10">
                <span className="text-xs font-semibold tracking-widest uppercase text-secondary-500">CONTACT</span>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-600 mt-2">
                  有任何问题或合作意向，欢迎留言联系我们
                </p>
              </div>

              <form
                onSubmit={handleSubmit}
               
                className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70 space-y-5"
              >
                <div className="form-website-alt-wrap">
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-2">
                      姓名 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="contact-name"
                      type="text"
                      name="name"
                      required
                      className="w-full bg-background-50 border border-background-200 rounded-lg px-4 py-3 text-sm text-foreground-950 outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-2">
                      邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="contact-email"
                      type="email"
                      name="email"
                      required
                      className="w-full bg-background-50 border border-background-200 rounded-lg px-4 py-3 text-sm text-foreground-950 outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-2">
                    主题
                  </label>
                  <select
                    id="contact-subject"
                    name="subject"
                    className="w-full bg-background-50 border border-background-200 rounded-lg px-4 py-3 text-sm text-foreground-950 outline-none focus:border-primary-400 transition-colors"
                  >
                    <option value="">请选择咨询主题</option>
                    <option value="爆料投稿">爆料投稿</option>
                    <option value="商务合作">商务合作</option>
                    <option value="广告投放">广告投放</option>
                    <option value="意见建议">意见建议</option>
                    <option value="其他问题">其他问题</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-2">
                    留言内容 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full bg-background-50 border border-background-200 rounded-lg px-4 py-3 text-sm text-foreground-950 outline-none focus:border-primary-400 transition-colors resize-none"
                    placeholder="请输入您的留言（500字以内）"
                  />
                  <p className="text-xs text-foreground-500 mt-1 text-right">最多500字</p>
                </div>

                <div className="flex items-center gap-3">
                  <input
                    id="contact-agree"
                    type="checkbox"
                    name="agree"
                    required
                    className="w-4 h-4 rounded border-background-300 text-primary-500 focus:ring-primary-400"
                  />
                  <label htmlFor="contact-agree" className="text-xs text-foreground-600">
                    我同意吃瓜爆料网的<a href="#" className="text-primary-500 hover:underline cursor-pointer">用户协议</a>和<a href="#" className="text-primary-500 hover:underline cursor-pointer">隐私政策</a>
                  </label>
                </div>

                <button
                  type="submit"
                  disabled={formStatus === 'loading'}
                  className="whitespace-nowrap w-full py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {formStatus === 'loading' ? '提交中...' : '发送留言'}
                </button>

                {formStatus === 'success' && (
                  <div className="text-center py-2">
                    <p className="text-sm text-green-600 font-medium">{formMessage}</p>
                  </div>
                )}
                {formStatus === 'error' && (
                  <div className="text-center py-2">
                    <p className="text-sm text-primary-600 font-medium">{formMessage}</p>
                  </div>
                )}
              </form>

              {/* 联系方式 */}
              <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="bg-background-100 rounded-2xl p-6 border border-background-200/70">
                  <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                    <i className="ri-mail-line text-lg text-primary-500" />
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h3>
                  <p className="text-xs text-foreground-600">hello@91flj.cn</p>
                </div>
                <div className="bg-background-100 rounded-2xl p-6 border border-background-200/70">
                  <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                    <i className="ri-smartphone-line text-lg text-accent-500" />
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">APP下载</h3>
                  <p className="text-xs text-foreground-600">访问官网或最新地址即可下载</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}